import axios from './index';
import type { components } from '@/typings/openapi';
import type { ResType } from '@/typings/common';

/**
 * Types from OpenAPI (`pnpm api:sync` → src/typings/openapi.d.ts)
 * Apifox schema title 为「角色 Role」
 */
export type RoleDataResult = components['schemas']['角色 Role'];
export type CreateRoleData = Pick<RoleDataResult, 'name' | 'permissions' | 'status'>;
export type UpdateRoleData = Partial<CreateRoleData>;

/**
 * APIs（与 OpenAPI 对齐：GET 无参、PATCH 更新、无 GET by id/name）
 */
export const roleListApi = (query?: Record<string, any>) => {
    return axios<ResType<RoleDataResult[]>>('/v1/roles', {
        method: 'get',
        params: query,
    });
};

export const deleteRoleByIdApi = (id: string) => {
    return axios<ResType<RoleDataResult>>(`/v1/roles/${id}`, {
        method: 'delete',
    });
};

export const createRoleApi = (data: CreateRoleData) => {
    return axios<ResType<RoleDataResult>>('/v1/roles', {
        data,
        method: 'post',
    });
};

export const updateRoleApi = (id: string, data: UpdateRoleData) => {
    return axios<ResType<RoleDataResult>>(`/v1/roles/${id}`, {
        data,
        method: 'patch',
    });
};
